module.exports = __webpack_public_path__ + "img/720x534.cd70fe45.jpg";